var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"container-fluid mt-4 mx-2 px-3"},[_c('DashboardFilters')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }